import { render } from "./Signature.vue?vue&type=template&id=ff82b120&scoped=true&ts=true"
import script from "./Signature.vue?vue&type=script&lang=ts"
export * from "./Signature.vue?vue&type=script&lang=ts"

import "./Signature.vue?vue&type=style&index=0&id=ff82b120&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff82b120"]])

export default __exports__